<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { onMount } from 'svelte';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOSetState } from '../../../../../js/ycapp';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig;
$: endWorkflow = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.endWorkflow) || false;
$: linkStore = findSourceStore($sources, 'YinzCamSignonServerLinks');
$: links = linkStore && ($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: connected = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.find(l => (l === null || l === void 0 ? void 0 : l.Type) === 'NFLID') : null) || false;
$: usePing = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.usePing) || false;
$: baseUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.baseUri) || "https://id.nfl.com";
$: apiKey = encodeURIComponent((clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.apiKey) || "");
$: clientId = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.clientId) || "";
$: clientIdParam = encodeURIComponent(clientId);
$: redirectUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.redirectUri) || new URL("/modals/en/NFLIDOpenIDRedirect", document.baseURI).href;
$: redirectUriParam = encodeURIComponent(redirectUri);
$: scope = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.scope) || "openid profile email";
$: scopeParam = encodeURIComponent(scope);
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    function afterConnect() {
        if (endWorkflow) {
            signonManager.fireWorkflowEndEvent();
        }
        else if (signonManager.skipCompleteProfilePage) {
            resolveUrl(`ConnectAccounts`).func();
        }
        else {
            resolveUrl(`CompleteProfile`).func();
        }
    }
    if (connected) {
        afterConnect();
    }
    const codeVerifier = signonManager.generatePKCECodeVerifier();
    const challenge = yield signonManager.generatePKCEChallenge(codeVerifier);
    window.localStorage.setItem('NFLIDOpenIDCodeVerifier', codeVerifier);
    const state = 'yinzcam';
    const tpaConfig = Object.assign({ url: `${baseUri}/oidc/op/v1.0/${apiKey}/authorize?client_id=${clientIdParam}&scope=${scopeParam}&response_type=code&redirect_uri=${redirectUriParam}&code_challenge=${challenge}&code_challenge_method=S256&state=${state}`, redirectUri }, ((!_.isNil(clientConfig.ephemeral)) ? { ephemeral: clientConfig.ephemeral } : undefined));
    ycSSOThirdPartyAuth("OAUTH", tpaConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d;
        console.log("ycSSOThirdPartyAuth callback inside OAUTH (NFLIDOpenID)", method, clientResult);
        const codeVerifier = window.localStorage.getItem('NFLIDOpenIDCodeVerifier');
        window.localStorage.removeItem('NFLIDOpenIDCodeVerifier');
        if (clientResult === null || clientResult === void 0 ? void 0 : clientResult.error) {
            console.error('Client Error: ' + clientResult.error);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.redirectUri)) {
            console.warn(`ycSSOThirdPartyAuth callback for OAUTH (NFLIDOpenID): missing redirectUri`);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const redirectParams = new URL(clientResult.redirectUri).searchParams;
        const checkState = redirectParams.get('state');
        if (checkState !== state) {
            alert("Missing or invalid NFLID OpenID response.");
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const code = redirectParams.get('code');
        if (!code || !codeVerifier) {
            alert("Missing or invalid NFLID OpenID response.");
            signonManager.fireWorkflowEndEvent();
            return;
        }
        let result = yield signonManager.loginWithNFLIDOpenID(clientId, scope, redirectUri, code, codeVerifier, usePing);
        //alert(`SSO login complete: ${JSON.stringify(result)}`);
        if (result.success) {
            ycSSOSetState(result.data.AccountCreated === 'true', result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
            afterConnect();
        }
        else {
            alert(((_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c.UserMessage) === null || _d === void 0 ? void 0 : _d.Content) || 'An error occurred.');
            signonManager.fireWorkflowEndEvent();
        }
    }));
}));
</script>

<CardBase {element}>
</CardBase>
